import gql from 'graphql-tag';

import slackChannelsPageFragment from '../fragments/slackChannelsPageFragment';

export default gql`
  query slackChannelsPage(
    $credentialID: DokkioID!
    $offset: Int
    $count: Int
  ) {
    slackChannelsPage(
      credentialID: $credentialID
      offset: $offset
      count: $count
    ) {
      ...slackChannelsPageFragment
    }
  }
  ${slackChannelsPageFragment}
`;
